module.exports = __webpack_public_path__ + "img/NaturesProphet.bcc217cf.png";